import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { GlobalsService } from "src/app/api/globals.service";
import { TranslationLoadedService } from "src/app/services/translation-loaded.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-reproductor-audio-libro",
  templateUrl: "./reproductor-audio-libro.component.html",
  styleUrls: ["./reproductor-audio-libro.component.scss"],
})
export class ReproductorAudioLibroComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription;
  @Input() listAudiBook: any[] = [];
  @Input() imgPortada: string = ""; // Imagen de portada del libro
  @Output() indexSong = new EventEmitter<number>();
  @Output() isFullScreen = new EventEmitter<boolean>();
  public audio: HTMLAudioElement = new Audio();
  public currentSongIndex: number = 0;
  public isPlaying = false;
  public isPaused = false;
  public isStopped = true;
  dataLoaded = false;
  audioURL = environment.host + "/web/uploads/assets/audios/productos/";
  ismobile: boolean;
  activeButton: 'play' | 'pause' | 'stop' | null = null;
  constructor(
    private router: Router,
    public globalsService: GlobalsService,
    private _translationLoadedService: TranslationLoadedService
  ) {
    this.ismobile = globalsService.isMobile;

    this._translationLoadedService.startLoading();
    this._translationLoadedService.isLoading$.subscribe((isLoading) => {
      this.dataLoaded = isLoading;
      if (!this.dataLoaded) {
        setTimeout(() => {
          this._translationLoadedService.finishLoading();
        }, 1100);
      }
    });
  }
  ngOnInit() {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.pause();
      }
    });
    if (this.listAudiBook && this.listAudiBook.length > 0) {
      // Leer duración de los audios
      this.listAudiBook.forEach((item, index) => {
        const tempAudio = new Audio();
        tempAudio.src = this.audioURL + item.audio;
        tempAudio.load();

        tempAudio.addEventListener("loadedmetadata", () => {
          this.listAudiBook[index].duration = tempAudio.duration;
        });
      });
    }
  }
  play(index: number) {
    this.activeButton = 'play';
    this.indexSong.emit(this.currentSongIndex);
    const selected = this.listAudiBook[index];
    // Si ya está sonando y no está pausado, no hacer nada
    if (this.currentSongIndex === index && this.isPlaying) {
      return;
    }

    // Si ya está pausado y es el mismo audio → solo continuar
    if (this.currentSongIndex === index && this.isPaused) {
      this.audio.play();
      this.isPlaying = true;
      this.isPaused = false;
      this.isStopped = false;
      return;
    }

    // Cambiar fuente solo si es nuevo audio
    this.audio.src = this.audioURL + selected.audio;
    this.audio.currentTime = selected.currentime || 0;
    this.audio.load();
    this.audio.play();

    this.isPlaying = true;
    this.isPaused = false;
    this.isStopped = false;
    this.currentSongIndex = index;

    this.audio.ontimeupdate = () => {
      selected.currentime = this.audio.currentTime;
    };

    this.audio.onended = () => {
      this.isPlaying = false;
      this.isPaused = false;
      this.isStopped = true;
    };
  }

  pause() {
    this.activeButton = 'pause';
    this.audio.pause();
    this.isPlaying = false;
    this.isPaused = true;
    this.isStopped = false;
    this.indexSong.emit(this.currentSongIndex);
  }

  restart() {
    this.activeButton = 'stop';
    this.audio.pause();
    this.audio.currentTime = 0;
    this.isPlaying = false;
    this.isPaused = false;
    this.isStopped = true;
    this.indexSong.emit(this.currentSongIndex);
  }

  seekTo(event: any) {
    const value = event.detail.value;
    this.audio.currentTime = value;
    this.listAudiBook[this.currentSongIndex].currentime = value;
  }

  formatTime(time: number): string {
    if (!time || isNaN(time)) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
  }
  getColor(index: number): string {
    const colors = ["#00e676", "#ffb300", "#2979ff"];
    return colors[index % colors.length];
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
